import { connect } from 'react-redux';
import {
  getDashboardEvents,
  getDashboardEnteredFormula,
  getIsFormulaOnly,
} from '../../../../../reducers/analyticsApp';
import { enterFormula, changeFormulaOnly } from '../../../../../actions/dashboards/events';
import EventFormula from '../../../../../components/dashboards/cards/builder/event/EventFormula';

const mapStateToProps = (state, { unit }) => {
  const events = getDashboardEvents(state, unit.id);
  const enteredFormula = getDashboardEnteredFormula(state, unit.id);
  const isFormulaOnly = getIsFormulaOnly(state, unit.id);

  return {
    events,
    enteredFormula,
    isFormulaOnly,
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  onChangeFormula: (formula) => dispatch(enterFormula(unit.id, formula)),
  onChangeFormulaOnly: () => dispatch(changeFormulaOnly(unit.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventFormula);
